export default {
	'auth': {
		'client': '0891e640-f364-11ea-9541-3134910b629b'
	},
	'url'   : 'https://api.fitnessdadivano.com',
	'stripe': 'pk_live_51JQ71wK65LosA3lCaV6Sx4WSCALYDSSSRtYGRTpJxqquN8EnQipK8KVgAPHVRSpCwjE3EMm6lhGNsaWk8Mipn1sE005bem95LO'
}
